import React, { useRef, useState, useEffect, useLayoutEffect } from "react";
import axios from "axios";
import gsap from "gsap";
import { mirage } from "ldrs";
import localforage from "localforage";
import { FaRegFilePdf } from "react-icons/fa6";
import { HiOutlineDownload } from "react-icons/hi";
import { FaBookmark } from "react-icons/fa6";
import { MdNavigateNext } from "react-icons/md";
var type;
const Memo = () => {
  mirage.register();
  const loader = useRef(null);
  const messageText = useRef(null);
  const message = useRef(null);
  const messageSpanSvg = useRef(null);
  const input_pass = useRef(null);
  const memotype = useRef(null);
  const [saved, setsaved] = useState(true);
  const [newlielement, setnewlielement] = useState(false);
  const [pass, setPass] = useState("");
  const [subTitle, setsubTitle] = useState("");
  useEffect(() => {
    document.querySelector(".pdf").addEventListener("click", () => {
      window.print();
    });
  }, []);
  useEffect(() => {
    showMemos();
  }, []);
  const fetchData = async (type) => {
    const pass = await localforage.getItem("passcode");
    if (pass) {
      showloader();
      try {
        const data = {
          type: type,
        };
        const response = await axios.post(
          "https://joodyy.netlify.app/.netlify/functions/app/create/getmemo",
          data
        );
        if (response.data.state === true) {
          hideloader();
          var section = document.querySelector("section");
          section.innerHTML = "";
          hideCreateMemoForm();
          response.data.memos.map((data) => {
            var output = creatememo(data);
            section.appendChild(output);
          });
        } else {
          hideloader();
          setsaved(null);
          await showMessage(response.data.message);
        }
      } catch (error) {
        setsaved(null);
        hideloader();
        await showMessage("server error");
      }
    } else {
      show();
    }
  };
  const tl = gsap.timeline({});
  function creatememo(data) {
    var result = document.createElement("div");
    result.innerHTML = "";
    result.classList.add("result");
    result.dataset.id = data.id;
    var h4 = document.createElement("h4");
    h4.id = "Q";
    var spansvg = `<span id="gemini-svg">
              <svg
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
              >
                <path
                  d="M16 8.016A8.522 8.522 0 008.016 16h-.032A8.521 8.521 0 000 8.016v-.032A8.521 8.521 0 007.984 0h.032A8.522 8.522 0 0016 7.984v.032z"
                  fill="url(#prefix__paint0_radial_980_20147)"
                />
                <defs>
                  <radialGradient
                    id="prefix__paint0_radial_980_20147"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="matrix(16.1326 5.4553 -43.70045 129.2322 1.588 6.503)"
                  >
                    <stop offset=".067" stop-color="#9168C0" />
                    <stop offset=".343" stop-color="#5684D1" />
                    <stop offset=".672" stop-color="#1BA1E3" />
                  </radialGradient>
                </defs>
              </svg>
            </span>`;
    h4.innerHTML = spansvg;
    var question = data.question;
    h4.innerHTML += question;
    var actions = document.createElement("div");
    actions.id = "actions";
    var span = document.createElement("span");
    span.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--svg-true-clr)"><path d="M200-120v-640q0-33 23.5-56.5T280-840h400q33 0 56.5 23.5T760-760v640L480-240 200-120Z"/></svg>`;
    span.dataset.click = "true";
    var data2 = data;
    span.addEventListener("click", () => {
      tl.kill();

      if (span.dataset.click == "false") {
        const data = {
          id: data2.id,
          category: data2.category,
          question: data2.question,
          answer: data2.answer,
        };
        memo(data, span);
      } else {
        const data = {
          id: data2.id,
        };

        removememo(data, span);
      }
      // h4.appendChild(element);
    });
    actions.appendChild(span);
    var copy = document.createElement("span");
    copy.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--svg-false-clr)"><path d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z"/></svg>`;
    var copy_container = document.createElement("div");
    copy_container.innerHTML = data.answer;
    copy.addEventListener("click", async () => {
      var range = document.createRange();
      
      range.selectNode(result.querySelector(".result>#answer_text"));
      window.getSelection().removeAllRanges(); // clear current selection
      window.getSelection().addRange(range); // to select text
      document.execCommand("copy");
      window.getSelection().removeAllRanges();
      setsaved("done");
      await showMessage("text copied");
    });
    actions.appendChild(copy);
    // ? **********
    var share = document.createElement("span");
    share.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="var(--svg-false-clr)"><path d="M240-40q-33 0-56.5-23.5T160-120v-440q0-33 23.5-56.5T240-640h80q17 0 28.5 11.5T360-600q0 17-11.5 28.5T320-560h-80v440h480v-440h-80q-17 0-28.5-11.5T600-600q0-17 11.5-28.5T640-640h80q33 0 56.5 23.5T800-560v440q0 33-23.5 56.5T720-40H240Zm200-727-36 36q-12 12-28 11.5T348-732q-11-12-11.5-28t11.5-28l104-104q12-12 28-12t28 12l104 104q11 11 11 27.5T612-732q-12 12-28.5 12T555-732l-35-35v407q0 17-11.5 28.5T480-320q-17 0-28.5-11.5T440-360v-407Z"/></svg>`;
    share.addEventListener("click", async () => {
      if (navigator.share) {
        navigator
          .share({
            title: "joody Memo",
            url: `https://joody.netlify.app/share/${data._id}`,
            text: `Check out my ${data.category} memo: ...`,
          })
          .then(async () => {
            setsaved((prev) => (prev = ""));
            setsaved((prev) => (prev = "done"));
            await showMessage("memo shared");
          })
          .catch(async (error) => {
            setsaved(null);
            hideloader();
            await showMessage("server error");
          });
      } else {
        const textToCopy = `https://joody.netlify.app/share/${data._id}`;
        await navigator.clipboard.writeText(textToCopy);
        setsaved("done");
        await showMessage("link copied");
      }
    });
    actions.appendChild(share);
    // ? **********
    result.appendChild(h4);
    result.innerHTML += data.answer;
    result.appendChild(actions);
    return result;
  }
  function showloader() {
    gsap.to(loader.current, { opacity: 1 });
  }
  function hideloader() {
    gsap.to(loader.current, { opacity: 0 });
  }
  async function showMessage(text) {
    const tl = gsap.timeline({});
    message.current.style = "";
    await tl
      .fromTo(
        message.current,
        {
          top: "-2rem",
        },
        {
          top: "1rem",
          ease: "elastic.out(1,0.5)",
          duration: 1.5,
          overwrite: true,
        }
      )
      .fromTo(
        message.current,
        {
          minWidth: "0px",
        },
        {
          minWidth: "180px",
          ease: "elastic.out(1,0.75)",
          duration: 1,
        }
      )
      .fromTo(
        messageText.current,
        {
          opacity: 0,
          flexGrow: 0,
          textContent: "",
          height: "0",
        },
        {
          textContent: text,
          flexGrow: 1,
          height: "fit-content",
          opacity: 1,
        }
      )
      .fromTo(
        messageSpanSvg.current,
        {
          opacity: 0,
        },
        {
          opacity: 1,
        }
      )
      .to(messageText.current, {
        opacity: 0,
        delay: 2,
      })
      .to(messageText.current, {
        flexGrow: 0,
        height: "0",
      })
      .to(messageSpanSvg.current, {
        opacity: 0,
        delay: -1,
      })
      .to(messageText.current, {
        textContent: "",
      })
      .to(message.current, {
        minWidth: "0px",
      })
      .to(message.current, {
        top: "-3rem",
      });
  }
  async function memo(data, span) {
    console.log(data, span);
    const pass = await localforage.getItem("passcode");
    if (pass) {
      showloader();
      try {
        const response = await axios.post(
          "https://joodyy.netlify.app/.netlify/functions/app/create/memo",
          data
        );
        hideloader();
        if (response.data.state == true) {
          setsaved(true);
          span.dataset.click = "true";
          await showMessage(response.data.message);
        } else {
          setsaved(false);
          span.dataset.click = "false";
          await showMessage(response.data.message);
        }
      } catch (error) {
        setsaved(null);
        hideloader();
        await showMessage("server error");
      }
    } else {
      show();
    }
  }
  async function removememo(data, span) {
    console.log(data);

    const pass = await localforage.getItem("passcode");
    if (pass) {
      showloader();
      try {
        const response = await axios.post(
          "https://joodyy.netlify.app/.netlify/functions/app/create/removememo",
          data
        );
        hideloader();
        if (response.data.state == true) {
          setsaved(false);
          span.dataset.click = "false";
          await showMessage(response.data.message);
          document.querySelector(`[data-id="${data.id}"]`).remove();
        } else {
          setsaved(true);
          span.dataset.click = "true";
          await showMessage(response.data.message);
        }
      } catch (error) {
        setsaved(null);
        hideloader();
        await showMessage("server error");
      }
    } else {
      show();
    }
  }
  async function addpasscode() {
    showloader();
    try {
      const data = {
        pass: pass,
      };
      const response = await axios.post(
        "https://joodyy.netlify.app/.netlify/functions/app/create/pass",
        data
      );

      hideloader();
      if (response.data.state == true) {
        hide();
        await localforage.setItem("passcode", pass);
        showMemos();
      } else {
        setsaved(null);
        await showMessage(response.data.message);
      }
    } catch (error) {
      setsaved(null);
      hideloader();
      await showMessage("server error");
    }
  }
  function hide() {
    gsap.to(input_pass.current, {
      y: 100,
      opacity: 0,
      pointerEvents: "none",
      duration: 0.7,
      ease: "expo.out",
    });
  }
  function show() {
    var tl = gsap.timeline();
    tl.fromTo(
      input_pass.current,
      { y: 100, opacity: 0, pointerEvents: "none" },
      {
        y: 0,
        opacity: 1,
        pointerEvents: "all",
        duration: 0.7,
        ease: "expo.out",
      }
    );
  }
  async function showMemos() {
    const pass = await localforage.getItem("passcode");
    if (pass) {
      showloader();
      try {
        const res = await axios.get(
          "https://joodyy.netlify.app/.netlify/functions/app/create/allcategory"
        );
        if (res.data.state == true) {
          const newli = await res.data.allCategories.map((data, index) => (
            <li
              key={index}
              onClick={() => {
                type = data.category;
                setsubTitle((prev) => (prev = data.category));
                fetchData(type);
              }}
            >
              <span>
                <FaBookmark />
              </span>
              <p>{data.category}</p>
              <span>
                <MdNavigateNext />
              </span>
            </li>
          ));
          setnewlielement((prev) => (prev = newli));
          setTimeout(() => {
            playlist();
          }, 100);
        } else {
          tl.fromTo(
            memotype.current,
            { opacity: 0, pointerEvents: "none" },
            {
              opacity: 1,
              pointerEvents: "all",
              duration: 0.7,
              ease: "expo.out",
            }
          );
        }
        hideloader();
      } catch (error) {
        setsaved(null);
        hideloader();
        await showMessage("server error");
      }
    } else {
      show();
    }
  }
  function hideCreateMemoForm() {
    var tl = gsap.timeline();
    tl.to(memotype.current, {
      opacity: 0,
      pointerEvents: "none",
      duration: 0.7,
      ease: "expo.out",
    });
  }
  function playlist() {
    var tl = gsap.timeline();
    tl.fromTo(
      memotype.current,
      { opacity: 0, pointerEvents: "none" },
      {
        opacity: 1,
        pointerEvents: "all",
        duration: 0.7,
        ease: "expo.out",
      }
    ).fromTo(
      ".memotype__list>li",
      { opacity: 0, y: 10 },
      { opacity: 1, y: 0, stagger: 0.15 }
    );
  }
  const memoSaved = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-true-clr)"
    >
      <path d="m438-400 198-198-57-56-141 141-57-57-57 57 114 113ZM200-120v-640q0-33 23.5-56.5T280-840h400q33 0 56.5 23.5T760-760v640L480-240 200-120Z" />
    </svg>
  );
  const memoRemoved = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-true-clr)"
    >
      <path d="M840-680H600v-80h240v80ZM200-120v-640q0-33 23.5-56.5T280-840h240v80H280v518l200-86 200 86v-278h80v400L480-240 200-120Zm80-640h240-240Z" />
    </svg>
  );
  const error = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-true-clr)"
    >
      <path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 11.5 28.5T480-280Zm-40-160h80v-240h-80v240Zm40 360q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z" />
    </svg>
  );
  const done = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="var(--svg-true-clr)"
    >
      <path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" />
    </svg>
  );
  useEffect(() => {
    const holdDuration = 600; // Hold for 1 second (you can adjust this value)
    let holdTimeout;

    document.body.addEventListener("touchstart", function startHold() {
      holdTimeout = setTimeout(function activateFunction() {
        showMemos();
        // Your actual function code here
      }, holdDuration);
      setTimeout(() => {
        clearTimeout(holdTimeout);
      }, holdDuration + 500);
    });

    document.body.addEventListener("touchend", function stopHold() {
      clearTimeout(holdTimeout); // Clear the timeout if mouse is released
    });
    document.body.addEventListener("mousedown", function startHold() {
      holdTimeout = setTimeout(function activateFunction() {
        showMemos();
        // Your actual function code here
      }, holdDuration);
      setTimeout(() => {
        clearTimeout(holdTimeout);
      }, holdDuration + 500);
    });

    document.body.addEventListener("mouseup", function stopHold() {
      clearTimeout(holdTimeout); // Clear the timeout if mouse is released
    });
  }, []);
  return (
    <article
      onDoubleClick={() => {
        hide();
        hideCreateMemoForm();
      }}
    >
      <div className="pdf">
        <span>
          <FaRegFilePdf />
        </span>
        <button>
          <HiOutlineDownload />
        </button>
      </div>
      <div className="message" ref={message}>
        <p ref={messageText}></p>
        <span ref={messageSpanSvg}>
          {saved === false && memoRemoved}
          {saved === true && memoSaved}
          {saved === null && error}
          {saved === "done" && done}
        </span>
      </div>
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
        className="memotype"
        ref={memotype}
      >
        <div className="memotype__title">
          <h3>your memos</h3>
        </div>
        <ul className="memotype__list">{newlielement}</ul>
      </form>
      <form
        className="input_pass"
        ref={input_pass}
        onSubmit={(e) => {
          e.preventDefault();
          addpasscode();
        }}
      >
        <label htmlFor="pass">
          <p>enter passcode</p>
          <input
            type="text"
            id="pass"
            name="pass"
            onInput={(e) => {
              setPass(e.target.value);
            }}
          />
        </label>
        <span>
          <p>enter passcode to continue</p>
        </span>
      </form>
      <div className="hero">
        <h1 id="color">memo</h1>
        <h1 id="normal">
          {subTitle == "" && "check out your memo collection"}
          {subTitle !== "" && subTitle}
        </h1>
      </div>
      <section></section>
      <div className="loader" ref={loader}>
        <l-mirage size="60" speed="2.5" color="black"></l-mirage>
      </div>
    </article>
  );
};

export default Memo;
